module.exports = __webpack_public_path__ + "img/ctms_dataSta_img5.de3abff1.png";